import React from 'react';
import Navbar from '../components/Navbar';
import NewsletterCTA from '../components/NewsletterCTA';
import Footer from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

interface NewsletterProps {
  onNavigate: (page: string) => void;
}

const Newsletter: React.FC<NewsletterProps> = ({ onNavigate }) => {
  useSEO({
    title: 'Newsletter',
    description: 'Subscribe to the UTXOMacro newsletter — weekly Bitcoin on-chain signals, macro intelligence, and AI disruption insights delivered to your inbox.',
    url: 'https://utxomacro.com/newsletter',
    keywords: 'Bitcoin newsletter, macro newsletter, on-chain signals, UTXOMacro weekly',
  });
  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#0A0A0A' }}>
      <Navbar currentPage="newsletter" onNavigate={onNavigate} />
      <div className="flex-1 flex flex-col justify-center pt-16">
        <NewsletterCTA />
      </div>
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default Newsletter;
